import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import React from "react";
import PropTypes from "prop-types";
import scrollIntoView from "scroll-into-view-if-needed";
const listItemContainer = Component => {
  class WrappedListItem extends React.Component {
    constructor() {
      super(...arguments);
      _defineProperty(this, "handleOnClick", e => {
        const {
          suggestion,
          onClick
        } = this.props;
        this.context.onSuggestionClick(e, suggestion);
        if (onClick) onClick(e, suggestion);
      });
    }
    componentWillReceiveProps(_ref, _ref2) {
      let {
        position
      } = _ref;
      let {
        activeIndex
      } = _ref2;
      if (position == null) {
        return;
      }
      if (activeIndex === position) {
        // Ensures that if the menu items exceed the bounds of the menu, the
        // menu will scroll up or down as the user hits the arrow keys.
        scrollIntoView(this.li, {
          scrollMode: 'if-needed',
          behavior: 'auto'
        });
      }
    }
    render() {
      const {
        activeIndex
      } = this.context;
      const {
        position,
        suggestion,
        ...rest
      } = this.props;
      return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
        liRef: li => {
          this.li = li;
        },
        active: activeIndex === position,
        onMouseDown: this.handleOnClick
      }));
    }
  }
  process.env.NODE_ENV !== "production" ? WrappedListItem.propTypes = {
    suggestion: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onClick: PropTypes.func,
    position: PropTypes.number
  } : void 0;
  WrappedListItem.contextTypes = {
    activeIndex: PropTypes.number.isRequired,
    onSuggestionClick: PropTypes.func.isRequired
  };
  return WrappedListItem;
};
export default listItemContainer;